// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img1 from "../Assets/n1.png"
import img2 from "../Assets/JRF-1.jpg"
import img3 from "../Assets/s-2.jpg"
import img4 from "../Assets/toi1-1024x494.png"
import img5 from "../Assets/toi2-1024x518.png"
import img6 from "../Assets/toi-657x1024.jpg"
import img7 from "../Assets/chandigarh-1024x580.png"
import img8 from "../Assets/hindustan-507x1024.png"
import img9 from "../Assets/times-824x1024.png"


function News() {

    return (
        <div className="min-h-screen bg-white font-serif">
            <h2 className="text-2xl p-4 mt-8">Latest Patent Granted (Date of Grant: February 19, 2025)</h2>

            <div className="flex flex-col items-center p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img1}
                    alt="img1"
                    className="w-140 h-180 rounded shadow mb-4"
                />
            </div>
            <h2 className="text-2xl  p-4">Latest JRF Position (Last Date: September 1, 2024)</h2>
            <div className="flex flex-col items-center p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img2}
                    alt="img1"
                    className="w-140 h-180 rounded shadow mb-4"
                    
                />
            </div>
            <h2 className="text-2xl p-4">News:</h2>
            <div className="flex flex-col items-center  p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img3}
                    alt="img1"
                    className="w-120 h-100 rounded shadow mb-4"
                />
            </div>
            <h2 className="text-2xl p-4">The Times of India</h2>
            <div className="flex flex-col items-center  p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img4}
                    alt="img1"
                    className="w-140 h-180 rounded shadow mb-4"
                />
            </div>
            <h2 className="text-2xl p-4">The Times of India:</h2>
            <div className="flex flex-col items-center  p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img5}
                    alt="img1"
                    className="w-140 h-180 rounded shadow mb-4"
                />
            </div>
            <h2 className="text-2xl p-4">The Times of India:</h2>
            <div className="flex flex-col items-center p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img6}
                    alt="img1"
                    className="w-140 h-180 rounded shadow mb-4"
                />
            </div>
            <h2 className="text-2xl p-4">Tribune:</h2>
            <div className="flex flex-col items-center  p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img7}
                    alt="img1"
                    className="w-140 h-180 rounded shadow mb-4"
                />
            </div>
            <h2 className="text-2xl p-4">Hindustan Times:</h2>
            <div className="flex flex-col items-center  p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img8}
                    alt="img1"
                    className="w-140 h-180 rounded shadow mb-4"
                />
            </div>
            <h2 className="text-2xl p-4">The Times of India:</h2>
            <div className="flex flex-col items-center p-4 w-full">
                {/* Profile Image */}
                <img
                    src={img9}
                    alt="img1"
                    className="w-140 h-180 rounded shadow mb-4"
                />
            </div>
        </div>
    );
}

export default News;
